import Booking from "./Booking.jsx";

export default Booking;
